<template>
  <slot />
</template>

<script>
export default {
  data () {
    return {
      scrolling: false,
      scrollDirection: '',
      lastScrollTop: 0,
    }
  },
  mounted () {
    // this.fixHeader()
    // this.scrollEvents()
    this.megamenuHoverOut()

    this.locationDropdownToggle()


    // document.body.classList.remove('header-loading')
    // window.addEventListener('resize', this.mobileMenuHeight)
  },
  methods: {
    megamenuHoverOut () {
      const megamenus = [...document.querySelectorAll('.megamenu-outer-wrapper')]
      megamenus.forEach(megamenu => {
        megamenu.addEventListener('mouseover', e => {
          if (e.target.classList.contains('megamenu-outer-wrapper')) {
            megamenu.classList.add('hide')
            setTimeout(() => { megamenu.classList.remove('hide') }, 500)
          }
        })
      })
    },
    // updateScrollDirection () {
    //   const scrollTop = window.pageYOffset || document.documentElement.scrollTop

    //   if (scrollTop > this.lastScrollTop) {
    //     if (this.scrollDirection !== 'down') {
    //       this.scrollDirection = 'down'
    //       document.body.classList.add('page-scrolling--down')
    //       document.body.classList.remove('page-scrolling--up')
    //     }
    //   } else if (scrollTop < this.lastScrollTop) {
    //     if (this.scrollDirection !== 'up') {
    //       this.scrollDirection = 'up'
    //       document.body.classList.add('page-scrolling--up')
    //       document.body.classList.remove('page-scrolling--down')
    //     }
    //   }

    //   this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop
    // },

    // fixHeader () {
    //   if (window.scrollY > 60) {
    //     document.body.classList.add('page-scrolling')
    //   } else {
    //     document.body.classList.remove('page-scrolling')
    //   }
    // },

    // scrollEvents () {
    //   window.addEventListener('scroll', () => this.scrolling = true, { passive: true })

    //   setInterval(() => {
    //     if (this.scrolling) {
    //       this.scrolling = false
    //       this.fixHeader()
    //       this.updateScrollDirection()
    //     }
    //   },100)
    // },

    locationDropdownToggle () {
      const locationPicker = document.querySelector('.upper-header .location-picker')
      if (locationPicker) {
        locationPicker.querySelector('.location-picker__active').addEventListener('click', () => {
          locationPicker.classList.toggle('closed')
        })
      }
    }
  }
}
</script>
